import { render, staticRenderFns } from "./enlightenment.vue?vue&type=template&id=1363b2c1&scoped=true"
import script from "./enlightenment.vue?vue&type=script&lang=js"
export * from "./enlightenment.vue?vue&type=script&lang=js"
import style0 from "./enlightenment.vue?vue&type=style&index=0&id=1363b2c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1363b2c1",
  null
  
)

export default component.exports